import { NewsletterComponent } from './../components/newsletter/newsletter.component';
import { SubscriberDetailComponent } from './../components/newsletter/subscriber-detail.component';
import { ConfirmationComponent } from './../shared/components/modal/confirmation/confirmation.component';
import { CampaignDetailComponent } from './../components/newsletter/campaign-detail.component';

export const newsletterRoutes = {
    path: 'newsletter',
    data: {
        breadcrumbs: {
            label: 'Newsletter',
            icon: 'newsletter'
        },
        state: 'newsletter'
    },
    children: [
        {
            path: '',
            component: NewsletterComponent
        },
        {
            path: 'subscribers/add',
            data: {
                breadcrumbs: {
                    label: 'Přidat odběratele'
                },
                state: 'subscribers-add'
            },
            children: [
                {
                    path: '',
                    component: SubscriberDetailComponent
                }
            ]
        },
        {
            path: 'subscribers/edit/:id',
            data: {
                breadcrumbs: {
                    label: 'Upravit odběratele'
                },
                state: 'subscribers-edit'
            },
            children: [
                {
                    path: '',
                    component: SubscriberDetailComponent
                }
            ]
        },
        {
            path: 'subscribers-delete/:id',
            component: ConfirmationComponent,
            data: {
                breadcrumbs: {
                    label: 'Smazat položku'
                },
                state: 'subscriber-delete',
                apiUri: 'subscribers'
            },
            outlet: 'modal'
        },
        {
            path: 'campaigns/add',
            data: {
                breadcrumbs: {
                    label: 'Přidat kampaň'
                },
                state: 'campaigns-add'
            },
            children: [
                {
                    path: '',
                    component: CampaignDetailComponent
                }
            ]
        },
        {
            path: 'campaigns/edit/:id',
            data: {
                breadcrumbs: {
                    label: 'Upravit kampaň'
                },
                state: 'campaigns-edit'
            },
            children: [
                {
                    path: '',
                    component: CampaignDetailComponent
                }
            ]
        },
        {
            path: 'campaigns-delete/:id',
            component: ConfirmationComponent,
            data: {
                breadcrumbs: {
                    label: 'Smazat položku'
                },
                state: 'campaign-delete',
                apiUri: 'campaigns'
            },
            outlet: 'modal'
        }
    ]
};
